import { useState } from 'react';

// @ts-expect-error type actually correct
export const useRscFriendlyState: typeof useState = (...args) => {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
    const value = typeof args[0] === 'function' ? args[0]() : args[0];

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return [
      value,
      () => {
        // empty
      },
    ];
  }

  return useState(...args);
};
